import { useEffect, useMemo, useRef, useState } from 'react';
import { client } from './axios';
import { useSearchParams } from 'react-router-dom';
import { labels } from './labels';

export function Stop() {
  const [isStopped, setIsStopped] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const [language, setLanguage] = useState<'swe' | 'eng'>('swe');
  const [activeSession, setActiveSession] = useState<boolean>(false);

  const intervalRef = useRef<any>(null);

  const track = searchParams.get('track');

  const getActiveSession = async () => {
    try {
      const response = await client.get('/gothiacup/session', {
        params: {
          track,
        },
      });

      if (response.data === '') {
        setActiveSession(false);
        return;
      }

      const { language } = response.data;
      setLanguage(language);
      setActiveSession(true);
    } catch (error) {
      setActiveSession(false);
    }
  };

  useEffect(() => {
    // Define the cleanup function outside of the effect
    const cleanup = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };

    // Set up the interval

    getActiveSession();

    intervalRef.current = setInterval(getActiveSession, 10000);

    // Cleanup on component unmount or before setting up a new interval
    return cleanup;
  }, [track]); // I

  const handleStop = async () => {
    try {
      await client.post('/gothiacup/stop', null, {
        params: {
          track,
        },
      });

      setIsStopped(true);

      const timeout = setTimeout(() => {
        setIsStopped(false);
        setActiveSession(false);
        clearTimeout(timeout);
      }, 3000);
    } catch (error) {
      console.error(error);
    }
  };

  const content = useMemo(() => {
    if (!activeSession) {
      return (
        <div className="w-screen h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat bg-zinc-100">
          <div className="flex flex-col bg-white border rounded-md p-6 gap-4 font-semibold border-slate-200">
            <label className="font-md text-lg">{labels['no_active_session'][language]}</label>
          </div>
        </div>
      );
    }

    return (
      <button
        disabled={isStopped}
        className="bg-red-500 border-[20px] uppercase border-[silver] disabled:opacity-50 text-white text-7xl font-semibold rounded-full h-96 w-96"
        onClick={handleStop}
      >
        {isStopped ? labels['stopped'][language] : labels['stop'][language]}
      </button>
    );
  }, [isStopped, activeSession]);

  if (track !== '1' && track !== '2') {
    return (
      <div>
        <h1>Invalid Track in URL: select '1' or '2'</h1>
      </div>
    );
  }

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat bg-zinc-100">
      <img src="https://jirangopub.s3.eu-north-1.amazonaws.com/Files/9962/SEB_Wordmark_RGB_Black.svg" className="h-12 absolute top-8 left-8" alt="SEB" />
      <h1 className="absolute top-10 text-4xl font-bold">
        {labels['track'][language]} {track}
      </h1>
      {content}
    </div>
  );
}
